import { LabelQueryString } from '@/app/shared/filter';
import { Breadcrumb } from '@/app/shared/interface/breadcrumb';
import { PaginationModel } from '@/app/shared/interface/product.interface';
import { AuthService } from '@/app/shared/services/auth.service';
import { ProductService } from '@/app/shared/services/product.service';
import { QueryStringService } from '@/app/shared/services/querystring.service';
import { SeoService } from '@/app/shared/services/seo.service';
import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';

@Component({
  selector: 'app-alternatives-product',
  templateUrl: './alternatives-product.component.html',
  styleUrl: './alternatives-product.component.scss'
})
export class AlternativesProductComponent {
  public breadcrumb: Breadcrumb = {
    title: 'Sản Phẩm thay thế cho',
    items: [{ label: 'Sản Phẩm', active: false, url: '/product' }, { label: 'Sản Phẩm thay thế', active: true }],
  };

  public gridClass: string = 'row product-list-section row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-2 my-0';
  isListView: boolean = false;
  public skeletonLoader: boolean = true;
  public skeletonItems = Array.from({ length: 40 }, (_, index) => index);

  public isAuthenticated: boolean = false;

  slug: string = '';

  nameOfMainProduct: any;

  alterProducts: any;

  public body: { productSkus: string[] } = {
    productSkus: []
  };

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private productService: ProductService,
    private queryStringService: QueryStringService,
    private seoService: SeoService,
  ) { }

  ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated();
    this.route.params.subscribe(params => {
      this.slug = params['slug'];
      if (this.slug) {
        this.fetchProductData(this.slug);
      } else {
        this.seoService.showNotFound();
      }
    });
  }

  async fetchProductData(slug: string) {
    try {
      this.skeletonLoader = true;
      const product = await firstValueFrom(this.productService.getProductBySlug(slug));
      if (product) {
        this.nameOfMainProduct = product.name;
        this.breadcrumb.items[this.breadcrumb.items.length - 1].label =
          `Sản Phẩm Thay Thế cho ${this.nameOfMainProduct}`;

        if (product.productAlternatives && product.productAlternatives.length > 0) {
          this.body.productSkus = product.productAlternatives.map(alt => alt.sku);
          await this.getAlterProducts();
        } else {
          this.alterProducts = [];
          this.skeletonLoader = false;
        }
      } else {
        this.seoService.showNotFound();
      }
    } catch (err) {
      console.error(err);
      this.skeletonLoader = false;
      this.seoService.showNotFound();
    }
  }

  setGridClass(gridClass: any) {
    this.gridClass = gridClass.class;
    this.isListView = gridClass.isListView;
  }

  async getAlterProducts() {
    try {
      this.skeletonLoader = true;
      if (this.body.productSkus.length === 0) {
        this.alterProducts = [];
        return;
      }

      const bodyStr = JSON.stringify(this.body);
      const obs = this.isAuthenticated
        ? this.productService.getProductsForMember(bodyStr)
        : this.productService.getProductsForGuest(bodyStr);

      const res = await firstValueFrom(obs);

      if (res) {
        this.alterProducts = res.products;
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.skeletonLoader = false;
    }
  }

  queryStringBuilder(event: any) {
    const newLabel = new LabelQueryString(event);
    const currentQueryStrings = this.queryStringService.queryString;
    const otherQueryStrings = currentQueryStrings.filter(qs => !(qs instanceof LabelQueryString));
    const mergedQueryStrings = [...otherQueryStrings, newLabel];
    this.queryStringService.changeQueryString(mergedQueryStrings);
  }
}
